import * as _ from 'underscore';
import { CheckboxState } from '../../common/components/checkboxes/CheckboxState';
import { IUserInfo } from '../models/IUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ServerUsers } from '../resources/ServerUsers';
import { IUpdateServerUsersSiteMembershipParams } from '../ServerApi/requests/UpdateServerUsersSiteMembershipRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { IServerUser } from '../ServerApi/types/IServerUser';
import { ISiteRole } from '../ServerApi/types/ISiteRole';
import { IUserRole } from '../ServerApi/types/IUserRole';
import { ServerAdminUpdateActionNotification } from './UserActionNotification';

export interface IUsersWithSiteRolesModel {
  users: Set<IServerUser>;
  userRoles: IUserRole[];
  serverAdmins: string[]; // user ids
}

export interface ISiteRoleChange {
  checkboxState?: string;
  siteRole?: string;
  siteName: string;
}

export class SiteRolesPickerClientService {

  public static $inject = [
    'ServerAdminUpdateActionNotification',
    'ServerUsers'];

  constructor(
    private serverAdminUpdateActionNotification: ServerAdminUpdateActionNotification,
    private serverUsers: ServerUsers) {
  }

  // section: update site membership or roles

  // Takes userids and site role changes and package them into a parameter
  // object that can be used for backend requests.
  public siteRoleChangesToParams(userIds: string[], changes: _.Dictionary<ISiteRoleChange>): IUpdateServerUsersSiteMembershipParams {

    const addToSiteRoles: ISiteRole[] = [];
    const removeFromSiteIds: string[] = [];
    _.each(changes, (change: ISiteRoleChange, siteId: string) => {
      if (change.checkboxState === CheckboxState.checked) {
        addToSiteRoles.push({
          siteId: siteId,
          siteRole: change.siteRole
        });
      } else if (change.checkboxState === CheckboxState.empty) {
        removeFromSiteIds.push(siteId);
      }
    });

    return {
      userIds: userIds,
      addToSiteRoles: addToSiteRoles,
      removeFromSiteIds: removeFromSiteIds
    };
  }

  // Exactly the same as ServerUsers.updateServerUsersSiteMembership, except that
  // this one directly takes a parameters object.
  public updateServerUsersSiteMembership(params: IUpdateServerUsersSiteMembershipParams): ng.IPromise<any> {
    return this.serverUsers.updateServerUsersSiteMembership(
      params.userIds,
      params.addToSiteRoles,
      params.removeFromSiteIds
    );
  }

  // section: update server admin

  public updateServerAdmin(users: Set<IUserInfo>, newAdminState: boolean): ng.IPromise<IResult> {
    const userIds = users.pluck('id');
    const promise: ng.IPromise<IResult> = this.serverUsers.updateServerAdminStatus(userIds, newAdminState);

    promise.then((result: IResult) => {
      this.serverAdminUpdateActionNotification.notify(result, users, newAdminState);
    });

    return promise;
  }

}

Module.instance().service('SiteRolesPickerClientService', SiteRolesPickerClientService);
